<template>
	<div class="horizontal-media-card bb py-150">
		<BaseLink :link="props.content.link" classes="display-flex align-items-center">
			<div class="display-flex gap-100 flex-1">
				<img :src="props.content.thumbnailUrl" alt="" role="presentation" class="horizontal-media-card__img" />
				<div class="horizontal-media-card__text">
					<h4 class="subheading text-color-content-primary" v-html="deorphanText(props.content.title)"></h4>
					<p
						v-if="!appStore.isMobile"
						data-test="horizontal-media-card-description"
						class="mt-25 text-color-content-secondary"
						v-html="deorphanText(props.content.description)"
					></p>
					<p class="mt-50 text-color-content-tertiary">{{
						date(props.content.date, CustomSpacetimeFormat.MONTH_DATE_YEAR)
					}}</p>
				</div>
			</div>
			<div v-if="!appStore.isMobile" class="text-color-content-primary">
				<BaseSvgIcon name="chevron" width="24" height="24" dir="right" />
			</div>
		</BaseLink>
	</div>
</template>

<script setup lang="ts">
import { date, deorphanText } from '@filters/shared-filters';
import { CustomSpacetimeFormat } from 'types/spacetime-formats';
import { HorizontalMediaCardContent } from 'types/marketing-site';
import { useAppStore } from '@stores/app';

interface Props {
	content: HorizontalMediaCardContent;
}

const props = defineProps<Props>();

const appStore = useAppStore();
</script>

<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;

.horizontal-media-card {
	&__img {
		width: 130px;
		height: 120px;
		object-fit: cover;
		border-radius: 4px;
	}

	svg.svg-icon {
		opacity: 0;
		transition: opacity 0.15s ease;
	}

	&:hover svg.svg-icon {
		opacity: 1;
	}

	&:hover {
		& .horizontal-media-card__text {
			h4,
			p {
				color: token('content-tertiary');
			}
		}
	}
}
</style>
